module.exports = __webpack_public_path__ + "img/vertical_6_1_8017.c5298148.png";